/* Badge buddy title pages (sections/badge-buddy-title-2026.liquid; Patrick, 2026-10-08).
 *
 * 1. bbtDraw(svg): draws a badge buddy the way the custom designer does (staging-2026
 *    snippets/bb-stage-svg.liquid + assets/custom-bb.js): the die geometry, the
 *    Minion Pro Bold advance table and the single-line sizing/placement rules ported
 *    from Simon's production renderer (bb-production-preview-v6). Only the one-line case
 *    is needed here: a title page prints one title.
 * 2. The buy box: orientation / size / color pick an "option" - a ready-made stock
 *    variant when one exists in that color, otherwise the designer product for that type
 *    and orientation. Price, tier row, part number, stock line, total and buttons follow.
 *
 * Deferred; init() draws every svg[data-die] first, then wires the buy box. */
(function () {
  var PPI = 72;
  var DIE = {
    'H-STD': { dieW: 3.375, dieH: 3.09375, cornerRadius: 0.1025, slotW: 0.553264, slotH: 0.125, slotTop: 0.225563, stripW: 3.069444, stripH: 1, stripBottomInset: 0.160014 },
    'V-STD': { dieW: 2.125, dieH: 4.5, cornerRadius: 0.1025, slotW: 0.553264, slotH: 0.125, slotTop: 0.185792, stripW: 1.875, stripH: 1.25, stripBottomInset: 0.120956 },
    'H-XL': { dieW: 3.375, dieH: 4.09375, cornerRadius: 0.1025, slotW: 0.553264, slotH: 0.125, slotTop: 0.225564, stripW: 3.069444, stripH: 1, stripBottomInset: 0.139993 },
    'V-XL': { dieW: 2.125, dieH: 5.5, cornerRadius: 0.1025, slotW: 0.553264, slotH: 0.125, slotTop: 0.185768, stripW: 1.875, stripH: 1.25, stripBottomInset: 0.127573 }
  };
  var PROFILES = {
    H: { sizingWidth: 3.0694, titleInsetSide: 0.0658, titleHeight: 1, maxFontSingle: 105, maxFontLine1: 45, maxFontLine2: 45, maxSumFont: 85 },
    V: { sizingWidth: 1.875, titleInsetSide: 0.0585, titleHeight: 1.25, maxFontSingle: 105, maxFontLine1: 75, maxFontLine2: 75, maxSumFont: 120 }
  };
  var REF = 20;
  var ADV = {" ":.217,"!":.285,'"':.38,"#":.5,$:.5,"%":.764,"&":.715,"'":.199,"(":.352,")":.352,"*":.405,"+":.577,",":.254,"-":.342,".":.254,"/":.327,0:.5,1:.5,2:.5,3:.5,4:.5,5:.5,6:.5,7:.5,8:.5,9:.5,":":.254,";":.254,"<":.548,"=":.577,">":.548,"?":.399,"@":.766,A:.706,B:.637,C:.676,D:.761,E:.581,F:.554,G:.727,H:.783,I:.378,J:.366,K:.703,L:.551,M:.888,N:.74,O:.766,P:.599,Q:.758,R:.659,S:.505,T:.641,U:.729,V:.711,W:.979,X:.693,Y:.655,Z:.619,"[":.351,"\\":.332,"]":.351,"^":.559,_:.5,"`":.4,a:.466,b:.534,c:.422,d:.547,e:.437,f:.331,g:.492,h:.55,i:.295,j:.288,k:.513,l:.278,m:.843,n:.566,o:.525,p:.547,q:.536,r:.404,s:.383,t:.339,u:.555,v:.465,w:.683,x:.482,y:.465,z:.445,"{":.357,"|":.27,"}":.357,"~":.577};
  var RAINBOW = ['#ff0000', '#ffa500', '#ffff00', '#008000', '#0000ff', '#800080'];
  var NS = 'http://www.w3.org/2000/svg';
  var uid = 0;

  function inch(v) { return v * PPI; }
  function roundTenth(v) {
    var s = v * 10, lo = Math.floor(s), f = s - lo;
    return Math.abs(f - 0.5) < 1e-10 ? (lo % 2 === 0 ? lo : lo + 1) / 10 : Math.round(s) / 10;
  }
  function measure(text, size) {
    var t = 0, c = String(text).split('');
    for (var i = 0; i < c.length; i++) t += (ADV[c[i]] == null ? 0.5 : ADV[c[i]]);
    return t * size;
  }
  function geometry(key) {
    var d = DIE[key];
    var w = inch(d.dieW), h = inch(d.dieH), sw = inch(d.stripW), sh = inch(d.stripH);
    var sx = (w - sw) / 2, sy = h - inch(d.stripBottomInset) - sh, slw = inch(d.slotW);
    return { w: w, h: h, r: inch(d.cornerRadius), sx: sx, sy: sy, sw: sw, sh: sh, sb: sy + sh, cx: w / 2,
      slx: (w - slw) / 2, sly: inch(d.slotTop), slw: slw, slh: inch(d.slotH) };
  }
  /* bbCalculateFontSizes + bbComputeTextLayout from staging-2026 assets/custom-bb.js, unchanged
   * (default font, no manual moves): one line (case A) or two (cases D/E). Pratik, 2026-10-07:
   * an untouched layout is left exactly as this reference algorithm places it, because it is
   * Simon's production algorithm. If Simon/Odin re-tune it, copy their numbers here too.
   * Returns [{text, size, width, x, y}, ...] in die points. */
  function hasDesc(t) { return /[gpqyjQ]/.test(t || ''); }
  function layout(orient, g, line1, line2) {
    var p = PROFILES[orient], isV = orient === 'V';
    var maxW = inch(p.sizingWidth - 2 * p.titleInsetSide - 0.1), maxH = inch(p.titleHeight - 0.1);
    function maxForWidth(t) { var w = measure(t, REF); return w <= 0 ? p.maxFontSingle : REF * maxW / w; }
    function place(t, size, y) { var w = measure(t, size); return { text: t, size: size, width: w, x: g.cx - w / 2, y: y }; }
    function descLift(t, size) { return hasDesc(t) ? size * 0.21 : 0; }
    if (line1 && line2) {
      var w1 = maxForWidth(line1), w2 = maxForWidth(line2), mh = maxH * 0.52;
      var f1 = Math.min(w1, mh, p.maxFontLine1), f2 = Math.min(w2, mh, p.maxFontLine2);
      if (line1.length > 3 && line2.length > 3) { var m = Math.min(f1, f2); f1 = m; f2 = m; }
      if (f1 + f2 > p.maxSumFont) { var r = p.maxSumFont / (f1 + f2); f1 *= r; f2 *= r; }
      f1 = roundTenth(Math.max(f1, 0.5)); f2 = roundTenth(Math.max(f2, 0.5));
      var lower = g.sb - inch(isV ? 0.153 : 0.082) - descLift(line2, f2);
      var upper = lower - f2 * 0.7 - inch(isV ? 0.109 : 0.059) - (hasDesc(line1) ? f1 * (isV ? 0.0625 : 0.125) : 0);
      return [place(line1, f1, upper), place(line2, f2, lower)];
    }
    var t = line1 || line2;
    if (!t) return [];
    var size = roundTenth(Math.max(Math.min(maxForWidth(t), p.maxFontSingle, maxH), 0.5));
    var inset = inch(isV ? 0.1265 : 0.0483) + (isV ? 0.0702 : 0.0723) * size + descLift(t, size);
    if (!isV && size >= 58) {
      var c = t.replace(/[^A-Za-z0-9]/g, '');
      if (c.length <= 3 && /[A-Za-z]/.test(c) && c === c.toUpperCase()) inset += Math.min(inch(0.09), size * 0.095);
    }
    return [place(t, size, g.sb - inset)];
  }
  function el(name, attrs, parent) {
    var n = document.createElementNS(NS, name);
    for (var k in attrs) n.setAttribute(k, attrs[k]);
    if (parent) parent.appendChild(n);
    return n;
  }

  /* data-die="H-STD|V-STD|H-XL|V-XL", data-clear, data-fill, data-ink ("#fff"/"#000" or "rainbow"),
     data-text. Redraws the whole SVG each time (a few elements). */
  window.bbtDraw = function (svg) {
    if (!svg) return;
    var key = svg.getAttribute('data-die') || 'H-STD';
    var orient = key.charAt(0);
    var clear = svg.getAttribute('data-clear') === 'true';
    var fill = svg.getAttribute('data-fill') || '#0067B9';
    var ink = svg.getAttribute('data-ink') || '#ffffff';
    var text = (svg.getAttribute('data-text') || '').replace(/\s+/g, ' ').trim();
    var text2 = (svg.getAttribute('data-text2') || '').replace(/\s+/g, ' ').trim();
    var g = geometry(key), id = 'bbt' + (++uid);
    while (svg.firstChild) svg.removeChild(svg.firstChild);
    svg.setAttribute('viewBox', '0 0 ' + g.w + ' ' + g.h);

    var defs = el('defs', {}, svg);
    var isRainbow = fill === 'rainbow';
    if (isRainbow) {
      var lg = el('linearGradient', { id: id + 'rb', x1: 0, y1: 0, x2: 0, y2: 1 }, defs);
      RAINBOW.forEach(function (c, i) {
        var a = [0, 16.6, 33.2, 49.8, 65.4, 83, 100];
        el('stop', { offset: a[i] + '%', 'stop-color': c }, lg);
        el('stop', { offset: a[i + 1] + '%', 'stop-color': c }, lg);
      });
    }
    if (clear) {
      var hl = el('linearGradient', { id: id + 'hl', x1: 0, y1: 0, x2: 1, y2: 1 }, defs);
      el('stop', { offset: '0%', 'stop-color': '#fff', 'stop-opacity': 0 }, hl);
      el('stop', { offset: '45%', 'stop-color': '#fff', 'stop-opacity': '.35' }, hl);
      el('stop', { offset: '60%', 'stop-color': '#fff', 'stop-opacity': 0 }, hl);
    }
    el('rect', clear
      ? { x: 0, y: 0, width: g.w, height: g.h, rx: g.r, fill: '#eef3f6', 'fill-opacity': '0.6', stroke: '#b9c3cb', 'stroke-width': 1.2 }
      : { x: 0, y: 0, width: g.w, height: g.h, rx: g.r, fill: '#ffffff', stroke: '#cdd3d8', 'stroke-width': 1.2 }, svg);
    if (clear) el('rect', { x: 0, y: 0, width: g.w, height: g.h, rx: g.r, fill: 'url(#' + id + 'hl)' }, svg);
    el('rect', { x: g.slx, y: g.sly, width: g.slw, height: g.slh, rx: g.slh / 2, fill: '#d5d9dc' }, svg);
    var stripFill = isRainbow ? 'url(#' + id + 'rb)' : fill;
    el('rect', { x: g.sx, y: g.sy, width: g.sw, height: g.sh, rx: inch(0.1), fill: stripFill, stroke: isRainbow ? 'none' : fill }, svg);
    var wm1 = el('text', { x: g.cx, y: g.sly + 17.64, 'font-size': 5.2, class: 'bbtp-wm' }, svg);
    wm1.textContent = 'Printed in the USA';
    var wm2 = el('text', { x: g.cx, y: g.sly + 17.64 + 6.64, 'font-size': 6.5, class: 'bbtp-wm bbtp-wm--brand' }, svg);
    wm2.textContent = 'SPECIALIST ID®';
    layout(orient, g, text, text2).forEach(function (L) {
      var t = el('text', { x: L.x, y: L.y, 'font-size': L.size, textLength: L.width, lengthAdjust: 'spacingAndGlyphs',
        class: 'bbtp-title', fill: isRainbow ? '#ffffff' : ink }, svg);
      if (isRainbow) { t.setAttribute('stroke', '#000'); t.setAttribute('stroke-width', (0.25 * PPI / 25.4 * 2).toFixed(4)); t.setAttribute('paint-order', 'stroke'); }
      t.textContent = L.text;
    });
    if (svg.getAttribute('data-card') === 'true') drawCard(svg, g, orient);
  };

  /* A sample Specialist ID hospital ID (CR80, 3-3/8 x 2-1/8 in) clipped in front of the badge
     buddy, as it's worn: same width as the buddy, slots lined up, the title bar showing below.
     Hidden until the option card is hovered or focused (bb-title-page.css). */
  function drawCard(svg, g, orient) {
    var isV = orient === 'V';
    var cw = isV ? inch(2.125) : inch(3.375), ch = isV ? inch(3.375) : inch(2.125);
    var grp = el('g', { class: 'bbtp-idcard' }, svg);
    el('rect', { x: 0, y: 0, width: cw, height: ch, rx: g.r, fill: '#ffffff', stroke: '#c4cacf', 'stroke-width': 1.2, class: 'bbtp-idcard__body' }, grp);
    el('rect', { x: g.slx, y: g.sly, width: g.slw, height: g.slh, rx: g.slh / 2, fill: '#e3e7ea' }, grp);
    var hy = g.sly + g.slh + 6, hh = isV ? 30 : 26;
    el('rect', { x: 0, y: hy, width: cw, height: hh, fill: '#3d6720' }, grp);
    var name = el('text', { x: cw / 2, y: hy + hh * 0.66, 'font-size': isV ? 11 : 10.5, class: 'bbtp-idcard__org', fill: '#ffffff' }, grp);
    name.textContent = 'BIG CITY HOSPITAL';
    var logo = window.BBT_LOGO;
    if (isV) {
      var py = hy + hh + 12, pw = 70, ph = 86;
      el('rect', { x: (cw - pw) / 2, y: py, width: pw, height: ph, rx: 4, fill: '#dfe4e8' }, grp);
      el('circle', { cx: cw / 2, cy: py + 32, r: 16, fill: '#b9c1c8' }, grp);
      el('path', { d: 'M' + (cw / 2 - 28) + ' ' + (py + ph) + ' q28 -40 56 0 z', fill: '#b9c1c8' }, grp);
      var n1 = el('text', { x: cw / 2, y: py + ph + 22, 'font-size': 13, class: 'bbtp-idcard__name' }, grp); n1.textContent = 'JANE SMITH';
      var n2 = el('text', { x: cw / 2, y: py + ph + 36, 'font-size': 8, class: 'bbtp-idcard__dept' }, grp); n2.textContent = 'Employee ID 04213';
      if (logo) el('image', { href: logo, x: cw / 2 - 30, y: ch - 32, width: 60, height: 24, preserveAspectRatio: 'xMidYMid meet' }, grp);
    } else {
      var px = 16, py2 = hy + hh + 10, pw2 = 56, ph2 = 68;
      el('rect', { x: px, y: py2, width: pw2, height: ph2, rx: 4, fill: '#dfe4e8' }, grp);
      el('circle', { cx: px + pw2 / 2, cy: py2 + 25, r: 13, fill: '#b9c1c8' }, grp);
      el('path', { d: 'M' + (px + 5) + ' ' + (py2 + ph2) + ' q' + (pw2 / 2 - 5) + ' -32 ' + (pw2 - 10) + ' 0 z', fill: '#b9c1c8' }, grp);
      var tx = px + pw2 + 14;
      var m1 = el('text', { x: tx, y: py2 + 24, 'font-size': 15, class: 'bbtp-idcard__name', 'text-anchor': 'start' }, grp); m1.textContent = 'JANE SMITH';
      var m2 = el('text', { x: tx, y: py2 + 40, 'font-size': 9, class: 'bbtp-idcard__dept', 'text-anchor': 'start' }, grp); m2.textContent = 'Employee ID 04213';
      if (logo) el('image', { href: logo, x: cw - 76, y: ch - 30, width: 62, height: 24, preserveAspectRatio: 'xMaxYMid meet' }, grp);
    }
  }

  /* ---------- Buy box ---------- */
  function listJoin(a) {
    a = a.filter(function (x, i) { return a.indexOf(x) === i; });
    return a.length < 3 ? a.join(' and ') : a.slice(0, -1).join(', ') + ' and ' + a[a.length - 1];
  }
  function money(cents, fmt) {
    var v = (cents / 100).toFixed(2);
    return (fmt || '${{amount}}').replace(/\{\{\s*amount\s*\}\}/, v.replace(/\B(?=(\d{3})+(?!\d))/g, ','));
  }

  function init() {
    var root = document.querySelector('[data-bbt]');
    var dataEl = document.querySelector('[data-bbt-data]');
    var D = null;
    if (dataEl) { try { D = JSON.parse(dataEl.textContent); } catch (e) { D = null; } }
    if (D && D.logo) window.BBT_LOGO = D.logo;
    // The script is deferred: draw every badge on the page first (stage, thumbnails, option cards).
    document.querySelectorAll('svg[data-die]').forEach(function (s) { window.bbtDraw(s); });
    if (!root || !D) return;

    var state = { orient: D.start.orient, type: D.start.type, color: D.start.color };
    var qtyInput = root.querySelector('[data-bbt-qty]');
    var stage = root.querySelector('[data-bbt-stage]');

    function colorInfo(name) { return D.colors.filter(function (c) { return c.name === name; })[0]; }
    function option() {
      var key = state.type + '-' + state.orient;
      var stock = D.stock.filter(function (s) { return s.type === state.type && s.orient === state.orient && s.color === state.color; })[0];
      if (stock) return { kind: 'stock', key: key, v: stock, p: D.products[stock.pid] };
      var d = D.designers[key];
      if (!d) return null;
      var vid = d.v[state.color];
      var p = D.products[d.pid];
      var v = p && p.variants.filter(function (x) { return x.id === vid; })[0];
      return { kind: 'custom', key: key, d: d, v: v, p: p };
    }
    function designUrl(type, orient, color) {
      var d = D.designers[type + '-' + orient];
      if (!d) return null;
      var q = [];
      if (d.v[color]) q.push('variant=' + d.v[color]);
      q.push('line1=' + encodeURIComponent(D.print));
      if (D.print2) q.push('line2=' + encodeURIComponent(D.print2));
      return d.url + '?' + q.join('&');
    }
    // Same math as the price ledger (snippets/bb-volume-tiers.liquid unitAt) and the product page, so the
    // price line and total match the table and checkout: a fixed tier takes its amount off; a percent tier
    // takes floor(price x pct) off, using the discount's exact percent when the volume-tier API has it
    // (2026-10-09: Math.round here showed $2.22 / $222.00 at 100+ where the table and checkout say $2.23).
    function unitPrice(o, qty) {
      var base = o.v ? o.v.price : o.p.price, best = base;
      var api = window.SPID_VolumeTiers;
      (o.p.tiers || []).forEach(function (t) {
        if (qty < t.q) return;
        var u;
        if (t.amt != null) { u = base - Math.round(t.amt * 100); }
        else {
          var pct = t.pct;
          if (api && api.percentForQuantity) { try { var x = api.percentForQuantity(t.q); if (x !== null && isFinite(x)) pct = x; } catch (e) {} }
          u = base - Math.floor(base * pct / 100);
        }
        best = (u > 0 && u <= base) ? u : base;
      });
      return best;
    }

    function syncPills(attr, val) {
      root.querySelectorAll('input[' + attr + ']').forEach(function (i) { i.checked = i.value === val; });
    }

    function render() {
      var c = colorInfo(state.color) || D.colors[0];
      if (state.type === 'clear' && c.name === 'Rainbow') { state.color = D.start.color; c = colorInfo(state.color); }
      var die = (state.orient === 'v' ? 'V' : 'H') + '-' + (state.type === 'xl' ? 'XL' : 'STD');
      var svg = root.querySelector('[data-bbt-main]');
      svg.setAttribute('data-die', die);
      svg.setAttribute('data-clear', state.type === 'clear');
      svg.setAttribute('data-fill', c.rainbow ? 'rainbow' : c.hex);
      svg.setAttribute('data-ink', c.ink);
      window.bbtDraw(svg);
      stage.setAttribute('data-orient', state.orient);
      root.querySelectorAll('[data-bbt-thumb="preview"] svg').forEach(function (s) {
        s.setAttribute('data-die', die); s.setAttribute('data-clear', state.type === 'clear');
        s.setAttribute('data-fill', c.rainbow ? 'rainbow' : c.hex); s.setAttribute('data-ink', c.ink); window.bbtDraw(s);
      });

      syncPills('data-bbt-orient', state.orient);
      syncPills('data-bbt-type', state.type);
      syncPills('data-bbt-color', state.color);
      root.querySelectorAll('input[data-bbt-color="Rainbow"]').forEach(function (i) {
        var lab = i.nextElementSibling; i.disabled = state.type === 'clear'; if (lab) lab.hidden = state.type === 'clear'; i.hidden = state.type === 'clear';
      });
      var cn = root.querySelector('[data-bbt-colorname]');
      if (cn) cn.textContent = state.color;

      var o = option();
      if (!o || !o.p) return;
      var isStock = o.kind === 'stock';
      root.querySelectorAll('[data-bbt-price-for]').forEach(function (b) { b.hidden = String(b.getAttribute('data-bbt-price-for')) !== String(o.p.id); });

      var lab2 = root.querySelector('[data-bbt-avail]');
      lab2.innerHTML = isStock ? '<span class="available_dot"></span> In stock' : '<span class="available_dot"></span> Made to order';
      root.querySelector('[data-bbt-lead]').textContent = isStock ? o.p.lead : o.p.lead;
      var sku = o.v ? o.v.sku : '';
      var pn = root.querySelector('[data-bbt-sku]');
      if (pn) { pn.textContent = sku; pn.closest('p').hidden = !sku; }

      var qty = Math.max(1, parseInt(qtyInput.value, 10) || 1);
      var unit = unitPrice(o, qty);
      root.querySelector('[data-bbt-total]').textContent = money(unit * qty, D.moneyFormat);
      root.querySelectorAll('[data-bbt-price-for]:not([hidden]) .bb-tier').forEach(function (cell) {
        cell.classList.remove('bb-tier--on');
      });
      var cells = root.querySelectorAll('[data-bbt-price-for]:not([hidden]) .bb-tier');
      var on = null;
      cells.forEach(function (cell) { if (qty >= parseInt(cell.getAttribute('data-tq') || '0', 10)) on = cell; });
      if (on) on.classList.add('bb-tier--on');
      root.querySelectorAll('[data-bbt-price-for]:not([hidden]) .product-price').forEach(function (pp) { pp.innerHTML = money(unit, D.moneyFormat) + '<span class="price-ea">ea</span>'; });
      // "Save N%" on the reserved small line below the price, as on every product page (2026-10-09 rev 2).
      // Tiers never strike a price; the line is always there (badge-buddy-title-2026.liquid), so nothing moves.
      var startU = unitPrice(o, parseInt(qtyInput.getAttribute('min'), 10) || 1);
      var savePct = unit < startU ? Math.floor((startU - unit) / startU * 100) : 0;
      var saveTxt = savePct > 0 ? 'Save ' + savePct + '%' : '';
      root.querySelectorAll('[data-bbt-price-for]:not([hidden]) .actual-price').forEach(function (ap) {
        var hs = ap.querySelector('.price-save');
        if (!hs) {
          hs = document.createElement('div');
          hs.className = 'price-save';
          ap.appendChild(hs);
        }
        if (hs.textContent !== saveTxt) hs.textContent = saveTxt;
      });

      var stockBox = root.querySelector('[data-bbt-stockform]');
      var customBox = root.querySelector('[data-bbt-customcta]');
      stockBox.hidden = !isStock; customBox.hidden = isStock;
      if (isStock) {
        root.querySelector('[data-bbt-variant]').value = o.v.id;
        root.querySelector('[data-bbt-leadprop]').value = o.p.lead;
      }
      var du = designUrl(state.type, state.orient, state.color);
      root.querySelectorAll('[data-bbt-design]').forEach(function (a) { if (du) a.href = du; });
      var qb = root.querySelectorAll('[data-bbt-quote]');
      qb.forEach(function (a) { a.href = a.getAttribute('data-base') + (sku ? '?sku=' + encodeURIComponent(sku) : ''); });

      var note = root.querySelector('[data-bbt-colornote]');
      if (note) {
        var have = D.stock.filter(function (s) { return s.type === state.type && s.orient === state.orient; }).map(function (s) { return s.color; });
        note.textContent = have.length
          ? (listJoin(have) + (have.length > 1 ? ' ship' : ' ships') + ' ready-made. Every other color is printed to order.')
          : '';
        note.hidden = !have.length;
      }

      root.querySelectorAll('[data-bbt-optlink]').forEach(function (a) {
        var k = a.getAttribute('data-bbt-optlink').split('-');
        var u = designUrl(k[0], k[1], state.color);
        if (u) a.href = u;
        var s = a.querySelector('svg');
        if (s) { s.setAttribute('data-fill', c.rainbow && k[0] !== 'clear' ? 'rainbow' : (c.rainbow ? D.colors[0].hex : c.hex)); s.setAttribute('data-ink', c.ink); window.bbtDraw(s); }
      });
    }

    root.addEventListener('change', function (e) {
      var t = e.target;
      if (t.hasAttribute('data-bbt-orient')) state.orient = t.value;
      else if (t.hasAttribute('data-bbt-type')) state.type = t.value;
      else if (t.hasAttribute('data-bbt-color')) state.color = t.value;
      else if (t.hasAttribute('data-bbt-qty')) { render(); return; }
      else return;
      // On the job stays up for a color, orientation or size change: the photo follows the color, and lifeFit
      // swaps to the photo of the new badge buddy (or back to the preview when there is none, e.g. clear).
      var lifeOn = life && !life.hidden && !t.hasAttribute('data-bbt-qty');
      if (!lifeOn) showPreview();
      render();
      lifeFit();
    });
    function lifeFit() {
      var lts = root.querySelectorAll('[data-bbt-thumb="life"]'), main = root.querySelector('[data-bbt-main]');
      if (!lts.length || !main) return;
      // Each photo shows one opaque badge buddy (data-life-die: horizontal standard, vertical standard, vertical XL,
      // 2026-10-15); only the ones matching the pick show. None yet for horizontal XL or clear.
      var die = main.getAttribute('data-die'), clear = main.getAttribute('data-clear') === 'true', first = null, current = null;
      lts.forEach(function (lt) {
        lt.hidden = clear || (lt.getAttribute('data-life-die') || 'H-STD') !== die;
        if (!lt.hidden && !first) first = lt;
        if (lt.classList.contains('is-active')) current = lt;
      });
      if (life && !life.hidden && current && current.hidden) {
        if (first) first.click(); else showPreview();
      }
    }
    qtyInput.addEventListener('input', render);
    root.querySelectorAll('[data-bbt-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        var v = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + parseInt(b.getAttribute('data-bbt-step'), 10));
        qtyInput.value = v; render();
      });
    });

    // Thumbnails: the live preview, or a real photo in the same pane.
    var photo = root.querySelector('[data-bbt-photo]');
    var life = root.querySelector('[data-bbt-life]');
    function showPreview() {
      photo.hidden = true; if (life) life.hidden = true; root.querySelector('[data-bbt-main]').style.display = '';
      root.querySelectorAll('[data-bbt-thumb]').forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-bbt-thumb') === 'preview'); });
    }
    root.querySelectorAll('[data-bbt-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        if (t.getAttribute('data-bbt-thumb') === 'preview') { showPreview(); return; }
        if (t.getAttribute('data-bbt-thumb') === 'life' && life) {
          // On the job: a lifestyle photo with this title and color (assets/bb-lifestyle.js).
          var which = t.getAttribute('data-life') || 'scrubs';
          life.querySelectorAll('[data-bbt-life-photo]').forEach(function (d) { d.hidden = d.getAttribute('data-bbt-life-photo') !== which; });
          photo.hidden = true; life.hidden = false; root.querySelector('[data-bbt-main]').style.display = 'none';
          root.querySelectorAll('[data-bbt-thumb]').forEach(function (x) { x.classList.toggle('is-active', x === t); });
          if (window.bbLife) life.querySelectorAll('[data-bb-life]').forEach(function (b) { window.bbLife.redraw(b); });
          return;
        }
        if (life) life.hidden = true;
        photo.src = t.getAttribute('data-src'); photo.alt = t.getAttribute('data-alt') || '';
        photo.hidden = false; root.querySelector('[data-bbt-main]').style.display = 'none';
        root.querySelectorAll('[data-bbt-thumb]').forEach(function (x) { x.classList.toggle('is-active', x === t); });
      });
    });

    render();
    lifeFit();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
